var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ handleSubmit }) {
              return [
                _c(
                  "form",
                  {
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return handleSubmit(_vm.clickAdd)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "form-row" }, [
                      _c(
                        "div",
                        { staticClass: "form-group col-md-12" },
                        [
                          _c("ValidationProvider", {
                            staticClass: "w-100",
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.foreignValue,
                                              expression: "foreignValue",
                                            },
                                          ],
                                          staticClass: "form-control w-100",
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.foreignValue = $event.target
                                                .multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: { disabled: "" },
                                              domProps: { value: null },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.i18n(
                                                      "Language.SelectLanguage"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _vm._l(
                                            _vm.foreignList,
                                            function (item) {
                                              return _c(
                                                "option",
                                                {
                                                  key: item.Guid,
                                                  domProps: { value: item },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.Name) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                      _vm.otherLanguage
                        ? _c(
                            "div",
                            { staticClass: "form-group col-md-12" },
                            [
                              _c("ValidationProvider", {
                                staticClass: "w-100",
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model.trim",
                                                value:
                                                  _vm.foreign
                                                    .LanguageDescription,
                                                expression:
                                                  "foreign.LanguageDescription",
                                                modifiers: { trim: true },
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "text",
                                              maxlength: "200",
                                              placeholder: "請填寫外語名稱",
                                            },
                                            domProps: {
                                              value:
                                                _vm.foreign.LanguageDescription,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.foreign,
                                                  "LanguageDescription",
                                                  $event.target.value.trim()
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.$forceUpdate()
                                              },
                                            },
                                          }),
                                          errors[0]
                                            ? _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(errors[0]) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "form-group col-md" },
                        [
                          _c("ValidationProvider", {
                            staticClass: "w-100",
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "col-form-label",
                                          staticStyle: {
                                            "margin-right": "5px",
                                          },
                                          attrs: { for: "" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.i18n("Language.Listen")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.foreign.Listen,
                                              expression: "foreign.Listen",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          staticStyle: {
                                            flex: "1",
                                            "min-width": "1px",
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.$set(
                                                _vm.foreign,
                                                "Listen",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: { disabled: "" },
                                              domProps: { value: null },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.i18n("Basic.Select")
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _vm._l(
                                            _vm.degreeList,
                                            function (item) {
                                              return _c(
                                                "option",
                                                {
                                                  key: item.Guid,
                                                  domProps: { value: item },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.Name) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "form-group col-md" },
                        [
                          _c("ValidationProvider", {
                            staticClass: "w-100",
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "col-form-label",
                                          staticStyle: {
                                            "margin-right": "5px",
                                          },
                                          attrs: { for: "" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.i18n("Language.Speak")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.foreign.Speak,
                                              expression: "foreign.Speak",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          staticStyle: {
                                            flex: "1",
                                            "min-width": "1px",
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.$set(
                                                _vm.foreign,
                                                "Speak",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: { disabled: "" },
                                              domProps: { value: null },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.i18n("Basic.Select")
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _vm._l(
                                            _vm.degreeList,
                                            function (item) {
                                              return _c(
                                                "option",
                                                {
                                                  key: item.Guid,
                                                  domProps: { value: item },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.Name) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "form-group col-md" },
                        [
                          _c("ValidationProvider", {
                            staticClass: "w-100",
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "col-form-label",
                                          staticStyle: {
                                            "margin-right": "5px",
                                          },
                                          attrs: { for: "" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.i18n("Language.Read")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.foreign.Read,
                                              expression: "foreign.Read",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          staticStyle: {
                                            flex: "1",
                                            "min-width": "1px",
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.$set(
                                                _vm.foreign,
                                                "Read",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: { disabled: "" },
                                              domProps: { value: null },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.i18n("Basic.Select")
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _vm._l(
                                            _vm.degreeList,
                                            function (item) {
                                              return _c(
                                                "option",
                                                {
                                                  key: item.Guid,
                                                  domProps: { value: item },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.Name) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "form-group col-md" },
                        [
                          _c("ValidationProvider", {
                            staticClass: "w-100",
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "col-form-label",
                                          staticStyle: {
                                            "margin-right": "5px",
                                          },
                                          attrs: { for: "" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.i18n("Language.Write")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.foreign.Write,
                                              expression: "foreign.Write",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          staticStyle: {
                                            flex: "1",
                                            "min-width": "1px",
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.$set(
                                                _vm.foreign,
                                                "Write",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: { disabled: "" },
                                              domProps: { value: null },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.i18n("Basic.Select")
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _vm._l(
                                            _vm.degreeList,
                                            function (item) {
                                              return _c(
                                                "option",
                                                {
                                                  key: item.Guid,
                                                  domProps: { value: item },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.Name) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "form-row" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary btn-sm",
                          staticStyle: {
                            "margin-left": "6px",
                            "margin-right": "10px",
                          },
                          attrs: { type: "button" },
                          on: { click: _vm.clickCancel },
                        },
                        [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Cancel")) + " ")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-sm",
                          attrs: { type: "submit" },
                        },
                        [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Save")) + " ")]
                      ),
                    ]),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }